import { render } from "./AdminIncidentsManagement.vue?vue&type=template&id=09dc9998&scoped=true"
import script from "./AdminIncidentsManagement.vue?vue&type=script&lang=js"
export * from "./AdminIncidentsManagement.vue?vue&type=script&lang=js"

import "./AdminIncidentsManagement.vue?vue&type=style&index=0&id=09dc9998&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09dc9998"]])

export default __exports__